module.exports = __webpack_public_path__ + "img/banner2.c64a97fe.jpg";